import { Injectable } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import { Time } from '../api.entities';
import { ApiService } from '../api.service';
import { extractDataAsOrThrow } from '../helpers';

@Injectable({
  providedIn: 'root',
})
export class TimeApi extends ApiService {
  getTime(timeZone: string = 'Europe/Stockholm'): Observable<string> {
    const query = { timeZone: timeZone.replace('/', '%2F') };

    return from(this.client.GET('/api/time', { params: { query } }).then(extractDataAsOrThrow)).pipe(
      map((response: Time) => response['dateTime'] as string)
    );
  }
}
